// 新增：清理超出数量限制的应用
export function cleanupExcessApps(state: any) {
  while (state.loadApps.length > state.maxNum) {
    const oldestApp = state.loadApps.shift()
    if (oldestApp?.app) {
      setTimeout(() => oldestApp.app.unmount(), 400)
    }
  }
}

// 新增：等待应用DOM渲染完成
export function waitForAppRender(microApp: any, context: any, timeout = 10000) {
  // 避免ESLint未使用变量警告
  // eslint-disable-next-line prefer-const
  let checkInterval: number
  // eslint-disable-next-line prefer-const
  let timeoutTimer: number

  const checkRenderStatus = () => {
    const container = document.querySelector(microApp.container)
    if (container?.innerHTML.trim()) {
      clearInterval(checkInterval)
      clearTimeout(timeoutTimer)
      context.commit('setMicroLoading', false)
    }
  }

  // 启动检查机制
  checkInterval = window.setInterval(checkRenderStatus, 100)
  timeoutTimer = window.setTimeout(async () => {
    clearInterval(checkInterval)
    context.commit('setMicroLoading', false)
    console.warn(`微应用${microApp.name}加载超时`)

    // 添加对 LOADING_SOURCE_CODE 状态的特殊处理
    const appIndex = context.state.loadApps.findIndex((item: any) => item.name === microApp.name)
    if (appIndex !== -1) {
      const appItem = context.state.loadApps[appIndex]

      // 使用更安全的卸载方式，添加错误处理
      if (appItem.app && typeof appItem.app.unmount === 'function') {
        try {
          console.log(`微应用 ${microApp.name} 状态为 ${appItem.app.getStatus?.() || 'NOT_LOADED'}`)
          await appItem.app.unmount()
        } catch (e) {
          console.warn(`卸载应用 ${microApp.name} 时出错:`, e)
        }
      }

      // 从loadApps中移除
      context.state.loadApps.splice(appIndex, 1)
      console.log(`已移除应用 ${microApp.name} 的旧实例`)
    }
  }, timeout)

  // 立即执行一次检查
  checkRenderStatus()
}
